var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationAnnouncementIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F93749",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5526 26.2761C20.3433 25.8572 19.9714 25.1131 20.9864 24.2664C21.2623 24.0363 22.2368 23.4031 23.4316 22.6266C24.9198 21.6595 26.7499 20.4702 27.9974 19.5612C28.2139 19.4035 28.3582 19.1688 28.4079 18.9057L29.3906 13.711C29.4626 13.3307 29.0352 13.0561 28.7191 13.2795L18.46 20.5334C17.5976 21.1232 16.1265 22.5031 17.1478 24.3568C17.967 25.8435 20.6404 26.4684 20.6404 26.4684C20.6223 26.4156 20.59 26.351 20.5526 26.2761ZM27.3811 21.7486C27.5905 22.1675 27.9623 22.9116 26.9473 23.7582C26.6714 23.9883 25.6969 24.6216 24.5021 25.3981C23.0139 26.3652 21.1838 27.5545 19.9363 28.4634C19.7199 28.6211 19.5756 28.8559 19.5258 29.119L18.5431 34.3136C18.4711 34.6939 18.8985 34.9686 19.2146 34.7451L29.4737 27.4913C30.3361 26.9015 31.8072 25.5216 30.7859 23.6679C29.9667 22.1811 27.2933 21.5563 27.2933 21.5563C27.3114 21.6091 27.3437 21.6736 27.3811 21.7486Z",
    fill: "#F93749"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAnnouncementIcon);
export default __webpack_public_path__ + "static/media/notification-announcement-icon.37119cceff0e06527332322b7fbc410b.svg";
export { ForwardRef as ReactComponent };